import { LosTab } from "./LosTab";

export default LosTab;